<template>
  <div class="rw-location-search" :class="wrapperClassObject">
    <label
      :for="elId"
      class="rwfc rwfc--select2"
      :class="{
        er: showErrorState,
        [cssClasses]: true,
        'rwfc--has-label': !hideLabel
      }"
    >
      <slot :hideLabel="hideLabel">
        <span class="the-text" :class="{ 'sr-only': hideLabel }">
          Enter A Location
        </span>
      </slot>
      <select class="rwfc__input select2" :id="elId" name="loc_cd"></select>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    hideLabel: {
      type: Boolean,
      default: true
    },
    endpoint: {
      type: String,
      required: true
    },
    elId: {
      type: String,
      default: 'rw-location-search'
    },
    selected: {
      type: Object,
      default: () => {}
    },
    showErrorState: {
      type: Boolean,
      default: false
    },
    placeholderText: {
      type: String,
      default: 'County, City, or Zipcode'
    },
    cssClasses: {
      type: String,
      defaults: ''
    },
    wrapperClasses: {
      type: String,
      defaults: ''
    },
    selectedUser: {
      type: Number
    }, // some scenarios require a selected user to query properties - if it is present, it will be included in requests
    resizeTrigger: {}, // if select2 needs to be re-initialized and resized, watch this to know when do to so (the library uses fixed widths)
    requestParams: {
      type: Object
    }
  },
  data() {
    const vm = this;
    return {
      select2Config: {
        placeholder: this.placeholderText,
        allowClear: true,
        ajax: {
          type: 'GET',
          delay: 500,
          url: this.endpoint,
          dataType: 'json',
          language: {
            noResults: function() {
              return "That's a miss.";
            }
          },
          escapeMarkup: function(markup) {
            return markup;
          },
          data: function(params) {
            let obj = {};

            obj.term = params.term;

            if (vm.selectedUser) obj.selected_user = vm.selectedUser;

            if (vm.requestParams && Object.keys(vm.requestParams).length > 0) {
              obj = {
                ...obj,
                ...vm.requestParams
              };
            }

            return obj;
          },
          processResults: function(data) {
            return data;
          },
          error: function() {
            return { results: [] };
          }
        },
        minimumInputLength: 2,
        templateResult: this.formatResults
      }
    };
  },
  computed: {
    wrapperClassObject() {
      return {
        [this.wrapperClasses]: this.wrapperClasses ? true : false,
        'rw-location-search--empty': !this.selected.text
      };
    }
  },
  mounted() {
    /* Init the select2 plugin */
    const vm = this;

    if(this.endpoint){
      this.initSelect2();      
    }

    window.onresize = event => this.resizeHandler(event);
  },
  methods: {
    formatResults(result) {
      
      var newChildren = [];
      if (result.text == 'Zipcodes') {
        newChildren = result.children.map(function(child) {
          return {
            id: 'zipcode-' + child.id,
            text: child.id + ' - ' + child.text,
            lng: child.lng,
            lat: child.lat
          };
        });
        result.text = $(
          '<div class="rw-select2-group-wrapper">' + result.text + '</div>'
        );
        result.children = newChildren;
      } else if (result.text == 'Listings') {
        newChildren = result.children.map(function(child) {
          return {
            id: 'lp-' + child.id,
            text: child.text
          };
        });
        result.text = $(
          '<div class="rw-select2-group-wrapper">' + result.text + '</div>'
        );
        result.children = newChildren;
      } else if (result.text == 'Rental Listings') {
        newChildren = result.children.map(function(child) {
          return {
            id: 'rl-' + child.id,
            text: `${child.text} - ${child.status.charAt(0).toUpperCase() + child.status.slice(1)}`,
          };
        });
        result.text = $(
                '<div class="rw-select2-group-wrapper">Rental Listings</div>'
        );
        result.children = newChildren;
      } else if (result.text == 'Offices') {
        newChildren = result.children.map(function(office) {
          return {
            id: 'office-' + office.id,
            text: office.name
          };
        });
        result.text = $('<div class="rw-select2-group-wrapper">Offices</div>');
        result.children = newChildren;
      } else if (
        result.text == 'Counties' ||
        result.text == 'Markets' ||
        result.text == 'Cities' ||
        result.text == 'Properties' ||
        result.text == 'States'
      ) {
        var prefix = '';
        switch (result.text) {
        case 'Properties':
          prefix = 'property';
          break;
        case 'States':
          prefix = 'state';
          break;
        case 'Counties':
          prefix = 'county';
          break;
        case 'Markets':
          prefix = 'market';
          break;
        case 'Cities':
          prefix = 'city';
          break;
        }
        newChildren = result.children.map(function(child) {
          let id = prefix + '-' + child.id;
          // `this` is undefined in this function
          if (window.RW_LOC_FORM.data.isResearchCenter)
            id = prefix + '_' + child.slug;

          return {
            id,
            text: child.text,
            lng: child.lng || false,
            lat: child.lat || false
          };
        });
        result.text = $(
          '<div class="rw-select2-group-wrapper">' + result.text + '</div>'
        );
        result.children = newChildren;
      }
      return result.text;
    },

    initEvents() {
      const vm = this;
      // Every time a selection is made from the dropdown
      $('#' + this.elId).on('select2:select', function(e) {
        var data = e.params.data;
        /* If the item selected starts with 'mls', we knbow it is a listing and we should redirect to its listng page */
        if (
          data.id &&
          typeof data.id == String &&
          data.id.indexOf('mls-') === 0
        ) {
          var hashParts = data.id.split('-');
          var listingHash = hashParts[1];
          window.location.replace('/listing/' + listingHash);
          return false;
        }
        vm.$emit('select2-select', e.params.data);
      });

      $('#' + this.elId).on('select2:unselect', function(e) {
        vm.$emit('select2-unselect');
      });

      $('#' + this.elId).on('select2:open', function(event) {
        this.value = null;
      });
    },

    resizeHandler: _.debounce(function(type, value) {
      this.initSelect2();
    }, 200),

    initSelect2(){
      if(!this.endpoint) {
        console.warn('Failed to intialize Select2 in LocationSearchInput');
        return false;
      }
      const LOCATION_SEARCH = $('#' + this.elId);
      LOCATION_SEARCH.select2(this.select2Config);
      this.initEvents();
    },
    
  },
  watch: {
    selected({ id, text }) {
      
      const LOCATION_SEARCH = $('#' + this.elId);

      /**
       *  IMPORTANT: This was added so that the dropdown can be "unset"
       */
      if(!id && text == '') {
        LOCATION_SEARCH.val('').trigger('change');
        return false;
      };

      let textContent = '';
      if(LOCATION_SEARCH[0] && LOCATION_SEARCH[0].selectedOptions[0]){
        textContent = LOCATION_SEARCH[0].selectedOptions[0].innerHTML;
      }

      if(text == textContent) return false;
      
      LOCATION_SEARCH.val('').trigger('change');
      var newOption = new Option(text, 1, false, false);
      LOCATION_SEARCH.append(newOption)
        .val(1)
        .trigger('change');
      return text;
    },
    resizeTrigger() {
      this.resizeHandler();
    },
    endpoint() {
      this.select2Config.ajax.url = this.endpoint;
      console.log('endpoint changed', this.endpoint);
      this.initSelect2();
    }
  }
};
</script>